<div
    class="main-container d-flex justify-content-center flex-nowrap w-100 h-100 font-m"
    data-uit="file-selection-item"
    [ngClass]="{ selectable: filesSelectable, selected: selected, 'text-muted': file.convertStatus === 'Failed' }"
    (click)="previewOutput('inline')"
>
    <div class="file-name-cnt d-flex flex-column flex-grow-2 justify-content-center flex-nowrap ps-4">
        <div class="d-flex justify-content-left align-items-center flex-nowrap pe-2">
            <span class="d-block overflow-hidden text-nowrap text-truncate" container="body" data-uit="selected-file-name">{{ file.name }}</span>
        </div>
    </div>
    <div *ngIf="showFileSize" class="size-cnt d-flex flex-column justify-content-center flex-nowrap flex-grow-1 text-center pe-2">
        <span class="overflow-hidden text-nowrap text-truncate">{{ file.sizeInBytes ? (file.sizeInBytes | fileSize) : '' }}</span>
    </div>
    <div class="action-col d-flex flex-column flex-grow-1 flex-nowrap justify-content-center">
        <div class="d-flex flex-nowrap justify-content-end">
            <button
                *ngIf="
                    file.url &&
                    isHttpOrHttpsUrl(file.url) &&
                    !isFilePreviewSupportedByArivis() &&
                    !(!isFilePreviewSupportedByArivis() && isSupportedByFilePreviewer()) &&
                    showViewIcon
                "
                type="button"
                data-uit="file-selection-edit-btn"
                class="btn ca-btn-icon"
                (click)="$event.stopPropagation(); editUrl()"
                [title]="'GENERAL.EDIT' | translate"
                data-uit="ca-edit-url-button"
            >
                <ca-icon name="pen" size="s"></ca-icon>
            </button>
            <button
                *ngIf="isFilePreviewSupportedByArivis() && isLoggedIn && showViewIcon"
                type="button"
                data-uit="file-selection-open-viewer-btn"
                class="btn ca-btn-icon"
                (click)="$event.stopPropagation(); openViewer()"
                [title]="'GENERAL.PREVIEW' | translate"
            >
                <ca-icon name="eye-open" size="s"></ca-icon>
            </button>
            <button
                #filePreview
                *ngIf="!isFilePreviewSupportedByArivis() && isSupportedByFilePreviewer() && isLoggedIn && showViewIcon"
                type="button"
                data-uit="file-selection-preview-btn"
                class="btn px-0 ca-btn-icon"
                (click)="$event.stopPropagation(); previewOutput()"
                [title]="'GENERAL.PREVIEW' | translate"
            >
                <ca-icon name="eye-open" size="s"></ca-icon>
            </button>
            <button
                [style.visibility]="!isDisabled ? 'visible' : 'hidden'"
                data-uit="ca-delete-input-file"
                type="button"
                class="btn ca-btn-icon"
                (click)="$event.stopPropagation(); remove(file)"
                [title]="'GENERAL.REMOVE' | translate"
            >
                <ca-icon name="cross" size="s" [ngClass]="{ 'text-danger': file.convertStatus === 'Failed' }"></ca-icon>
            </button>
        </div>
    </div>
</div>
